//import { IListResource } from '../../httpClient/resources/Resource';


import { RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { SpaceInfoItemTypeValue } from '~src/spacesPlatform/models/ContentType';

import { IGetGroupSetGroupsInfoResult, IGroupSetGroupInfo, IGroupSetInfo } from '../models/IGroupSetInfo';
import { IGetGroupSetDetailsResult } from './requests/GetAllGroupSetsRequest';

export module GroupSetsServerApiHelper {

    export function mapGroupSetsFromResult(result: IGetGroupSetDetailsResult): IGroupSetInfo[] {
        if (result.groupSets.groupSet.length > 0) {
            const mappedGroupSets = result.groupSets.groupSet.map((item, index) => ({
                ...item,
                contentType: SpaceInfoItemTypeValue.groupset
            }));
            return mappedGroupSets;
        }
        return [];
    }

    export function mapGroupSetGroupsFromResult(result: IGetGroupSetGroupsInfoResult): IGroupSetGroupInfo[] {
        if (result.group?.length > 0) {
            const mappedGroupSetGroups = result.group.map((item, index) => ({
                ...item,
                groupSetId: result.id,
                contentType: SpaceInfoItemTypeValue.group,
            }));
            return mappedGroupSetGroups;
        }
        return [];
    }

}

export function createBaseRestConfig(): Omit<RestApiRequestConfig<{}, {}>, 'endpoint' | 'httpMethod'> {
    return {
        restApiVersion: '3.22',
        requestBody: {}
    };
}